<template>
  <div class="c-pc-recommend" v-if="recommendList.length > 0">
    <h4 class="recommend-tit"><b>推荐会议</b></h4>
    <div v-for="list in recommendList" :key="list.id">
      <div class="recommend-list">
        <div class="recommend-cover">
          <a @click="toNewPager(list.url)" :class="{ 'a-no-hover': !list.url }">
            <img
              v-bind:src="list.pic || list.logoRealPath || defaultImage"
              alt=""
            />
          </a>
        </div>
        <div class="recommend-main">
          <div class="recommend-name" :title="list.title">
            {{ list.title }}
          </div>
          <div class="recommend-tags" v-for="(tag, i) in list.tags" :key="i">
            <div class="c-tag">{{ tag }}</div>
          </div>
          <!--<div class="recommend-opea">-->
          <!--<img src="../../assets/images/icon01.png" alt="" />-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { $subscriber, cr } from "fire-wind-water";
export default {
  name: "Recommend",
  data() {
    return {
      recommendList: {},
      defaultImage: require("../../assets/images/moren-tuijian.jpg")
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("recommendList", data => {
        this.recommendList = data;
      });
    },
    toNewPager(href) {
      if (href && href != "") {
        window.open(href);
      }
    }
  }
};
</script>

<style scoped></style>
